import { articleCards } from 'constants/routes';


/**
 * @param {{}} params
 * @param {number} params.page - The page number to fetch
 * @param {number} params.size - the number of cards to fetch per page
 * @param {Array.<string>} params.categories - list of category ids
 * @param {string} params.client - the client
 * @param {string} params.cardType - the type of card to use (meaning the template to use as cards are SSR'd)
 * @returns {Promise<string | null>}
 */
export default function getBlogArticleCards({ page, size, categories, client, cardType }) {
  const payload = {
    Page: page,
    PageSize: size,
    ContentClient: client,
    CategoryIds: categories,
    ArticleCardType: cardType,
  };

  return fetch(articleCards, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  }).then((response) => {
    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }
    return response.text();
  }).catch((error) => {
    console.error('Error fetching articles:', error);
    return null;
  });
}
